define('components/decorators/guide',[
    'jquery',
    '../util/tool-menu',
    'lib/cookies'
],function($, toolmenu, cookies){

    var root = $(document);
    var toolMenu = toolmenu.create({
        persist: true,
        className: "guide-tool-menu"
    });

    $.extend(companyInfo.decorators,{

        'guide': function(){

            var subject = this.getAttribute("data-guide-subject");
            var lang = document.documentElement.getAttribute("lang");
            var guide = guides[subject];
            var guideStarter = $(this);
            var cookieNameCompleted = subject + '-guide-completed';

            if ( !guide || cookies.get(cookieNameCompleted) ) {
                return;
            }

            var nextHandlerName = "next-" + subject + "-item";
            var prevHandlerName = "previous-" + subject + "-item";
            var doneHandlerName = "done-" + subject + "-item";
            var handlers = {};

            handlers[nextHandlerName] = showNext;
            handlers[prevHandlerName] = showPrevious;
            handlers[doneHandlerName] = hideGuide;
            $.extend(companyInfo.handlers,handlers);

            var guideTrack;
            var guideIndex = -1;

            guideStarter.on("click","button.start-guide", startGuide);
            guideStarter.on("click","button.close-guide", hideGuide);
            guideStarter.addClass('show-guide');

            function startGuide(){
                guideStarter.hide();
                guideIndex = -1;

                generateGuideTrack();
                showNext();
            }

            function hideGuide(){
                guideStarter.remove();
                toolMenu.hide();
                cookies.set(cookieNameCompleted, true);
            }

            function showPrevious(){
                var item = guideTrack[--guideIndex];
                if ( !item ) {
                    guideIndex = 0;
                    return;
                }
                toolMenu.show(item.html[0],$("[data-guide='"+item.at+"']"));
                toolMenu.scrollTo({offset:-200});
            }

            function showNext(){
                var item = guideTrack[++guideIndex];
                if ( !item ) {
                    guideIndex = guideTrack.length-1;
                    return;
                }
                toolMenu.show(item.html[0],$("[data-guide='"+item.at+"']"));
                toolMenu.scrollTo({offset:-200});
            }


            var tpl = "".concat(
                "<div class='guide-info'>",
                    "<div>{content}</div>",
                    "<div>",
                        "<span><strong>{count}</strong><span class='vantotal'>&nbsp;{of} {total}</span></span>",
                        "<button type='button' class='inline' data-handler='{prevHandler}' {prev-disabled}>{previous}</button>",
                        "<button type='button' class='submit' data-handler='{nextHandler}' {next-disabled}>{next}</button>",
                        "<button type='button' class='submit' data-handler='{doneHandler}' {done-disabled}>{done}</button>",
                    "</div>",
                "</div>"
            );

            var i18n = {
                nl: {
                    of: 'van',
                    previous: 'Vorige',
                    next: 'Volgende',
                    done: 'Klaar'
                },
                en: {
                    of: 'of',
                    previous: 'Previous',
                    next: 'Next',
                    done: 'Done'
                }
            };

            function generateGuideTrack() {
                guideTrack = [];
                var size = guide.length;
                var index = 0, html;
                var disabled = "disabled='disabled'";
                for(;index<size;index++) {
                    html = tpl.concat();
                    html = html.replace("{nextHandler}", nextHandlerName);
                    html = html.replace("{prevHandler}", prevHandlerName);
                    html = html.replace("{doneHandler}", doneHandlerName);
                    html = html.replace("{content}", guide[index][lang]);
                    html = html.replace("{count}",index+1);
                    html = html.replace("{total}", guide.length);
                    html = html.replace("{prev-disabled}", index===0 ? disabled : '' );
                    html = html.replace("{next-disabled}", index === (size-1) ? disabled : '' );
                    html = html.replace("{done-disabled}", index === (size-1) ? '' : disabled );
                    html = html.replace("{done}", i18n[lang].done);
                    html = html.replace("{of}", i18n[lang].of);
                    html = html.replace("{previous}", i18n[lang].previous);
                    html = html.replace("{next}", i18n[lang].next);
                    guideTrack.push({
                        at: subject + "-" + (index+1),
                        html: $(html)
                    });
                }
            }

        }

    });


    var guides = {
        "company-index": [
            {
                nl: "De Company Index geeft een rapportcijfer van 0 t/m 10 op basis van scores op verschillende indicatoren zoals solvabiliteit, winst en leeftijd.",
                en: "The Company Index grades organizations from 0 to 10 based on several indicators such as solvency, profit and age."
            },
            {
                nl: "Het sectorgemiddelde geeft een gemiddelde score op basis van de prestaties van organisaties met dezelfde SBI code.",
                en: "The sector average gives an average score based on the performance of organizations with the same SBI code."
            },
            {
                nl: "De historie geeft over een periode van 3 jaar de Company Index scores van de organisatie.",
                en: "The history shows the Company Index scores of the organization over a 3 year period."
            },
            {
                nl: "Hier heeft u de mogelijkheid om ontbrekende jaarrekeningen te kopen die nodig zijn om de meest actuele score te berekenen.",
                en: "This gives you the option to purchase any missing annual accounts needed to calculate the most recent score."
            }
        ]
    };

});

